import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@/core/services/auth.service';

/**
 * PublicGuard - Allows only non-authenticated users
 * Redirects to dashboard if user is already authenticated
 * Useful for login, register, forgot-password pages
 */
@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const isAuthenticated = await this.authService.isAuthenticated();
      if (isAuthenticated) {
        // Redirect authenticated users to dashboard (empty path root)
        this.router.navigate(['/']);
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error in PublicGuard:', error);
      return true;
    }
  }
}
